import React from 'react';
import { Tooltip, IconButton, Typography } from '@mui/material';
import Link from '../Link/Link';
import { FeedbackContainer } from './styles';
import { ReactComponent as FeedBackIcon } from '../../images/icons/submitFeedback.svg';
import { COMMUNITY_FORUM } from '../../utils/constants/general';

const Feedback = () => {
	return (
		<FeedbackContainer>
			<Tooltip href={COMMUNITY_FORUM.url} target="_blank" title="Submit feedback">
				<IconButton color="inherit">
					<FeedBackIcon alt="feedbackIcon" height={32} width={32} />
				</IconButton>
			</Tooltip>
			<Link href={COMMUNITY_FORUM.url} target="_blank">
				<Typography variant="subtitle2" component="h6">
					Feedback
				</Typography>
			</Link>
		</FeedbackContainer>
	);
};

export default Feedback;
